module.exports = __webpack_public_path__ + "img/icon3.cf57eaf1.svg";